import React from 'react'
import Icon from './Icon'
import Collapse from 'react-collapse'
import invariant from '../utils/invariant'

 const Drawer = ({titlePosition, open, onToggle, forced, children, className}) => {
  invariant(children.length == 2, "Drawer should have 2 child, the title, and the content")
  const iconName = open ? 'caret-up' : 'caret-down';
  return <div className={className ? className : ""}>
    <label onClick={onToggle}>
      {children[0]}
      {' '}
      {forced ? null : <Icon name={iconName}/>}
    </label>
    <Collapse isOpened={open || forced || false}>
      {children[1]}
    </Collapse>
  </div>;
}

Drawer.PropTypes = {
  titlePosition: React.PropTypes.oneOf(['left', 'right', 'center']),
  open: React.PropTypes.bool.isRequired,
  onToggle: React.PropTypes.func.isRequired,
  forced: React.PropTypes.bool,
  children: React.PropTypes.array.isRequired
}

export default Drawer;



/** WEBPACK FOOTER **
 ** ./app/components/Drawer.jsx
 **/